import Handlebars from 'handlebars';
import { date, templateHelpers, util } from '@glu/core';
import routeManager from '@glu/core/src/routeManager';
import locale from '@glu/locale';
import formats from 'system/formats';

const helpers = util.extend({}, templateHelpers, {
  defaultDateFormat: util.result(formats.date, 'client'),

  route(route, options) {
    const opts = (options && options.hash) ? options.hash : options;

    const routeToUse = routeManager[route] || route;

    if (opts && util.isFunction(routeToUse.params)) {
      return routeManager.root + routeToUse.params(opts);
    }

    return routeManager.root + routeToUse;
  },

  dateFormat(context, block) {
    let dateFormat = util.result(formats.date, 'client');
    if (typeof block === 'string') {
      dateFormat = block;
    }
    return date(context).format(dateFormat);
  },

  abbrNumber(value) {
    const val = +value || 0;

    if (val >= 0) {
      return templateHelpers.abbrNumber(val);
    }

    return `-${templateHelpers.abbrNumber(window.Math.abs(val))}`;
  },

  colorbar(options) {
    const className = (options?.hash || {}).className || '';
    return new Handlebars.SafeString(
      `<div class="colorbar ${
        className
      }"><div class="colbar-1"></div><div class="colbar-2"></div><div class="colbar-3"></div><div class="colbar-4"></div><div class="colbar-5"></div><div class="colbar-6"></div><div class="colbar-7"></div></div>`
    );
  },

  loader() {
    return new Handlebars.SafeString('<div class="loader loader-lg"></div>');
  },

  /**
     * This function exists in case we need to localise in future to a currency that
     * puts it's symbol at the end of the number. It doesn't add any value at the moment
     * but if it comes to it we can add the logic here to place the symbol in the correct
     * place for each currency.
     */
  amountWithCurrencySymbol(amount, currencyIsoCode) {
    return Handlebars.helpers.currencySymbol(currencyIsoCode) + Handlebars.helpers.amount(amount);
  },

  localeWithArgs(...args) {
    const argsAsArray = Array.prototype.slice.call(args);
    const stringArgs = argsAsArray.filter(arg => typeof arg === 'string' || typeof arg === 'number');
    return locale.get(...stringArgs);
  },

  hbs(handlebarsString) {
    return Handlebars.compile(handlebarsString)(this);
  },

  modelProp(propName) {
    return `<span data-bind="model" data-text="${propName}"></span>`;
  },

  formatCurrencyWithSymbol(amount, currencyIsoCode) {
    return Handlebars.helpers.currencySymbol(currencyIsoCode) + Number(amount).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 3 // Some European banks support 3 digits.
    });
  },
});

util.each(helpers, (fn, name) => {
  Handlebars.registerHelper(name, fn);
});

export default helpers;
